const focusFirstFormField = function () {
  const fieldSelector = [
    'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([disabled]):not([readonly])',
    'textarea:not([disabled]):not([readonly])',
    'select:not([disabled])'
  ].join(', ')

  $('form:visible').each(function () {
    const $firstField = $(this).find(fieldSelector).filter(':visible').first()

    if ($firstField.length) {
      $firstField[0].focus()
      return false
    }
  })
}

$(document).ready(focusFirstFormField)
$(document).on('turbo:load', focusFirstFormField)
